export default {
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                slug: this.getFormData("slug"),
                breadcrumb: this.getFormData("breadcrumb"),
                uri: this.getFormData("uri"),
                href_langs: this.getFormData("manual_href_langs"),
                parent_id: this.getFormData("parent_id"),
                parent: this.getFormData("parent"),
                parent_type: this.getFormData("parent_type"),
                meta_id: this.getFormData("meta_id"),
                meta: this.getFormData("meta"),
                status_id: this.getFormData("status_id"),
                status: this.getFormData("status"),
                h1_anchor: this.getFormData("h1_anchor"),
            },
        };
    },
    watch: {
        "form.meta": function (newValue) {
            this.form.meta_id = newValue ? newValue.id : null;
        },
        "form.status": function (newValue) {
            this.form.status_id = newValue ? newValue.id : null;
        },
        "form.parent": function (newValue) {
            this.form.parent_id = newValue ? newValue.id : null;
        },
    },
};
